import { StepShell, SectionGroup } from '../components/layout';
import { TextArea, DateField } from '../components/inputs';
import { ChoiceCards } from '../components/selection';

export default function InternshipPrefsStep({ data, update, notes = {}, config }) {
  return (
    <StepShell
      eyebrow="Step 15 of 18"
      title="How you’d like to work with us"
      lede="The practical side. Tell us what actually fits around your life — we would much rather know now than find out in week three."
      why="Programmes fall apart when the commitment does not match someone's real availability. Being straight with us here makes it far more likely to work."
    >
      <ChoiceCards
        label="Roughly how much time can you give?"
        options={config.availability}
        value={data.availability}
        note={notes.availability}
        columns={2}
        onChange={(v) => update({ availability: v })}
      />

      <ChoiceCards
        label="How would you prefer to work?"
        options={config.workModes}
        value={data.work_mode}
        note={notes.work_mode}
        columns={2}
        onChange={(v) => update({ work_mode: v })}
      />

      <ChoiceCards
        label="Which part of the day suits you?"
        options={config.shifts}
        value={data.preferred_shift}
        note={notes.preferred_shift}
        columns={3}
        onChange={(v) => update({ preferred_shift: v })}
      />

      <ChoiceCards
        label="How long would you like the programme to be?"
        options={config.durations}
        value={data.duration}
        note={notes.duration}
        columns={2}
        onChange={(v) => update({ duration: v })}
      />

      <SectionGroup label="Anything else we should plan around">
        <DateField
          id="earliest_start"
          label="Earliest you could start"
          optional
          value={data.earliest_start}
          note={notes.earliest_start}
          min={new Date().toISOString().slice(0, 10)}
          onChange={(v) => update({ earliest_start: v })}
        />

        <TextArea
          id="accessibility_needs"
          label="Anything that would help us support you properly"
          optional
          rows={3}
          maxLength={600}
          placeholder="Exam periods, accessibility needs, a health condition, other commitments — only what you are comfortable sharing."
          hint="Share only what you want to. This goes to the programme manager, not to your team."
          value={data.accessibility_needs}
          note={notes.accessibility_needs}
          onChange={(v) => update({ accessibility_needs: v })}
        />
      </SectionGroup>
    </StepShell>
  );
}
